import { Typography } from 'antd'
import { isNil } from 'lodash'

import { observer, useForm } from '@eastcoal/formily/exports/react'

import { AuditEnterpriseFormData } from '../interface'

export const AgentFeedBackText = observer(() => {
  const { values } = useForm<AuditEnterpriseFormData>()

  const isFirstAgentChange =
    isNil(values.previousAgentId) || values.previousAgentId === values.agentId

  const linkRef = `/templates/${
    isFirstAgentChange ? '竞价委托书(委托).docx' : '竞价委托书(含撤销).doc'
  }`

  return (
    <Typography.Text type='secondary'>
      <span>
        ①如果营业执照的“法定代表人”与企业的“业务受托人”不一致，则需提供企业的业务操作委托书
      </span>
      <br />
      <span>②请下载模板打印，并签字盖章后上传&nbsp;</span>
      <Typography.Link href={linkRef}>下载模板文件</Typography.Link>
    </Typography.Text>
  )
})
